<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px;height: auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Pridel Document</b-navbar-brand>

          <!-- <b-button
            size="sm"
            class="ml-1"
            @click="getReportsReverse('Document_Validator_LIST_EXCEL')"
            variant="outline-info"
            >Export as Excel</b-button
          > -->
          <b-button class="ml-1" :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
            @click="getReportsReverse('Document_Validator_LIST_EXCEL')" size="sm" variant="warning"> {{ ExcelBtnName }}
            <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12">
                  <h5>Pridel Document</h5>
                </b-col>
                <b-col md="3">
                  <b-col md="12" style="padding-left: 0">
                    <label>
                      Document Type
                      <span class="error">*</span>
                    </label>
                  </b-col>
                  <b-row>
                    <div class="col-9">
                      <model-list-select :list="All_Document_TypeList" v-model="DocumentValidatorMaster.fk_doc_type_id"
                        option-value="documentTypeId" option-text="documentName"
                        placeholder="Select Document Type"></model-list-select>
                    </div>
                    <div class="col-3">
                      <b-button variant="primary" @click="openDocumentValidatorModal()" id="addButtonLoader"
                        size="sm">Add</b-button>
                    </div>
                  </b-row>
                  <b-col md="12" style="padding-left: 0">
                    <span class="error" v-if="!DocumentValidatorMaster.fk_doc_type_id">
                      {{ errorList.fk_doc_type_id }}
                    </span>
                  </b-col>
                </b-col>
                <b-col md="3">
                  <label>
                    Document Number
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    :disabled="(DocumentValidatorMaster.documentvalidatorId > 0 || DocumentValidatorMaster.EmailSentStatus ==  0) ? true : false"
                    :formatter="capitalizeAll" id="documentNumber" name="documentNumber"
                    v-model="DocumentValidatorMaster.documentNumber" placeholder="Please Enter documentNumber"
                    type="text"></b-form-input>
                  <span class="error" v-if="!DocumentValidatorMaster.documentNumber">
                    {{ errorList.documentNumber }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Document Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="documentName" name="documentName"
                    v-model="DocumentValidatorMaster.documentName" placeholder="Document Name"></b-form-input>
                  <span class="error" v-if="!DocumentValidatorMaster.documentName">
                    {{ errorList.documentName }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Document Issue Date
                    <span class="error">*</span>
                  </label>
                  <date-picker :format="selectDateFormat" lang="en" width="100%"
                    v-model="DocumentValidatorMaster.documentIssueDate" type="date" id="documentIssueDate"
                    placeholder="Document Issue Date"
                    @change="EndDateSelect(DocumentValidatorMaster.documentIssueDate, DocumentValidatorMaster.EmailSentStatus)"></date-picker>
                  <span class="error" v-if="!DocumentValidatorMaster.documentIssueDate">
                    {{ errorList.documentIssueDate }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Document End Date
                    <span class="error">*</span>
                  </label>
                  <date-picker width="100%" :format="selectDateFormat" lang="en" id="documentEndDate"
                    name="documentEndDate" placeholder="Document End Date"
                    v-model="DocumentValidatorMaster.documentEndDate"></date-picker>
                  <span class="error" v-if="!DocumentValidatorMaster.documentEndDate">
                    {{ errorList.documentEndDate }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Document Reminder Date
                    <span class="error">*</span>
                  </label>
                  <date-picker width="100%" :format="selectDateFormat" lang="en" id="documentRemainderDate"
                    name="documentRemainderDate" placeholder="Document Reminder Date"
                    v-model="DocumentValidatorMaster.documentRemainderDate"></date-picker>
                  <span class="error" v-if="!DocumentValidatorMaster.documentRemainderDate">
                    {{ errorList.documentRemainderDate }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>Status :</label>
                  <md-switch :id="'approval' + DocumentValidatorMaster.isDocumentActive" name="approval"
                    class="md-primary" :value="DocumentValidatorMaster.isDocumentActive == 1 ? true : false"
                    @change="activateDocumentValidatorMaster()">
                    <h6>
                      <b-badge :variant="
                          DocumentValidatorMaster.isDocumentActive == 1
                            ? 'success'
                            : 'danger'
                        ">{{
                        DocumentValidatorMaster.isDocumentActive == 1
                        ? "Active"
                        : "In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="3">
                  <label>
                    Email TO
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="ToEmail" name="ToEmail"
                    v-model="DocumentValidatorMaster.ToEmail" placeholder="Email TO"></b-form-input>
                  <span class="error" v-if="!DocumentValidatorMaster.ToEmail">
                    {{ errorList.ToEmail }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Email CC
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="CCEmail" name="CCEmail"
                    v-model="DocumentValidatorMaster.CCEmail" placeholder="Email CC"></b-form-input>
                  <span class="error" v-if="!DocumentValidatorMaster.CCEmail">
                    {{ errorList.CCEmail }}
                  </span>
                </b-col>
                <b-col md="6">
                  <label>
                    Document File
                    <span class="error">*</span>
                  </label>
                  <multi-file-uploader :style="'height: 80px; background: darkgray; width: 100%'"
                    :documentName="'pridel_validated_doc'" :otherDocName="'pridel_validated_doc'"
                    :folderName="'pridel_validated_doc'" :accept="'*'" :assign_no="'pridel_validated_doc'"
                    :multiple="true" v-model="DocumentValidatorMaster.documentFileName"
                    :state="Boolean(DocumentValidatorMaster.documentFileName)"
                    :fileAllModuleId="DocumentValidatorMaster.documentvalidatorId"></multi-file-uploader>
                  <span class="error" v-if="!DocumentValidatorMaster.documentFileName">
                    {{ errorList.documentFileName }}
                  </span>
                  <b v-if="
                      DocumentValidatorMaster.documentFileName != '' &&
                      DocumentValidatorMaster.documentFileName != undefined &&
                      DocumentValidatorMaster.documentFileName != null
                    ">
                    <span v-for="(item_doc, index_doc) in DocumentValidatorMaster.documentFileName.split(',')"
                      :key="index_doc">
                      <a v-if="item_doc != ''" href="javascript:void(0)" @click="PrintValidity_Doc(item_doc)">View Doc -
                        {{ index_doc + 1 }}</a>
                      <br />
                    </span>
                  </b>
                </b-col>
                <b-col md="6">
                  <label>Document Remarks</label>
                  <b-form-textarea :formatter="capitalizeAll" id="documentRemarks" name="documentRemarks"
                    v-model="DocumentValidatorMaster.documentRemarks"></b-form-textarea>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addDocumentValidatorMaster"
                      class="mt-2" id="addButtonLoader">
                      {{
                      DocumentValidatorMaster.EmailSentStatus == 1 ? "Renewal" : (
                      DocumentValidatorMaster.documentvalidatorId ? "Update" : "Save" )
                      }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <!-- Document Type Modal Added By Shreshth Gahlot Start -->
            <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="DocumentType-modal" hide-footer
              title="Add DocumentType">
              <b-row class="justify-content-center">
                <b-col md="4">
                  <label>Document Name <span class="error">*</span></label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="documentName" name="documentName"
                    v-model="DocumentTypeModal.documentName"></b-form-input>
                  <span class="error" v-if="!DocumentTypeModal.documentName">{{
                    DocumenterrorList.documentName
                    }}</span>
                </b-col>
                <b-col md="4">
                  <label>Description </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="description" name="description"
                    v-model="DocumentTypeModal.description"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="my-3 text-center">
                  <b-button variant="outline-primary" @click="addDocumentType" id="addButtonLoader"
                    size="sm">Save</b-button>
                  <b-button variant="outline-danger" class="ml-2" size="sm" @click="hideDocumentType">Close</b-button>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-modal>
            <!-- Document Type Modal Added By Shreshth Gahlot End -->

            <!-- All Pridel Document List According To User Added By Shreshth Gahlot Start -->
            <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="DocumentList-modal" hide-footer
              title="All Pridel Document List">
              <b-table show-empty stacked="md" :items="All_Pridel_Document_data" responsive :fields="HistoryColumns"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                class="position-relative">
                <template slot="pri_docId" slot-scope="row0">
                  <span>
                    {{ row0.index + 1 + (currentPage - 1) * perPage }}
                  </span>
                </template>
                <template slot="Username" slot-scope="row1">
                  <span>{{
                    row1.item.Username != "" ? row1.item.Username : "--"
                    }}</span>
                </template>
                <template slot="documentName" slot-scope="row2">
                  <span>{{
                    row2.item.documentName != "" ? row2.item.documentName : "--"
                    }}</span>
                </template>
                <template slot="pri_docName" slot-scope="row3">
                  <b-button style="margin-left: 2px;margin-bottom: 2px; font-size: 0.675rem" v-if="doc_item != ''"
                    @click="PrintValidity_Doc(row3.item.pri_docName)" size="sm" variant="success">View Doc </b-button>

                </template>
                <template slot="startDate" slot-scope="row4">
                  <span>{{
                    row4.item.startDate != "" ? row4.item.startDate : "--"
                    }}</span>
                </template>
                <template slot="EndDate" slot-scope="row5">
                  <span>{{
                    row5.item.EndDate != "" ? row5.item.EndDate : "--"
                    }}</span>
                </template>
              </b-table>
            </b-modal>
            <!-- All Pridel Document List According To User Added By Shreshth Gahlot End -->

            <!-- Search Form Input Start-->
            <div class="mt-3">
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Charges Master and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
            </div>
            <!-- Search Form Input End-->

            <div class="mt-3">
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                
                <b-table show-empty stacked="md" :items="All_Document_Validator_List_data" responsive :fields="Columns"
                  primary-key="common_over_id" :per-page="perPage" :current-page="currentPage" :filter="filter"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                  class="position-relative">
                  <template slot="idmasterChargers" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="priDocNumber" slot-scope="row9">
                    <span>
                      {{
                      row9.item.priDocNumber !=
                      "" ? row9.item.priDocNumber : "--"
                      }}
                    </span>
                  </template>
                  <template slot="documentTypeName" slot-scope="row1">
                    <span>{{
                      row1.item.documentTypeName != "" ? row1.item.documentTypeName : "--"
                      }}</span>
                  </template>
                  <template slot="documentName" slot-scope="row2">
                    <span>{{
                      row2.item.documentName != "" ? row2.item.documentName : "--"
                      }}</span>
                  </template>
                  <template slot="documentIssueDate" slot-scope="row3">
                    <span><b>Issue Date </b>{{ row3.item.documentIssueDate | moment }}</span>
                    <br />
                    <span><b>Reminder Date </b>{{ row3.item.documentRemainderDate | moment }}</span>
                  </template>
                  <template slot="documentEndDate" slot-scope="row4">
                    <span>{{ row4.item.documentEndDate | moment }}</span><br/>
                    
                  </template>
                  <template slot="ToEmail" slot-scope="row5">
                    <span> Email TO: <b>{{ row5.item.ToEmail }}</b></span>
                    <br>
                    <span> Email CC: <b>{{ row5.item.CCEmail }}</b></span>
                  </template>
                  <template slot="documentFileName" slot-scope="row7">
                    <span v-for="(doc_item, doc_index) in row7.item.documentFileName.split(',')" :key="doc_index">
                      <b-button style="margin-left: 2px;margin-bottom: 2px; font-size: 0.675rem" v-if="doc_item != ''"
                        @click="PrintValidity_Doc(doc_item)" size="sm" variant="success">View Doc {{ doc_index + 1 }}
                      </b-button>
                    </span>
                  </template>
                  <template slot="isDocumentActive" slot-scope="row22">
                    <div v-if="adminToggle =='Admin'" :id="'row'+row22.item.documentvalidatorId">
                      <md-switch :id="'approval'+row22.item.documentvalidatorId" name="approval" class="md-primary"
                        :value="row22.item.isDocumentActive==1?true:false"
                        @change="activateDocumentValidator(row22.item)">
                        <h6>
                          <br>
                          <b-badge
                            style="margin-left:-45px">{{row22.item.isDocumentActive==1?'Active':'In-Active'}}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row'+row22.item.documentvalidatorId">
                      <h6>
                        <!-- <b-badge>{{row22.item.isDocumentActive==1?'Active':'In-Active'}}</b-badge> -->
                        <b-badge >{{row22.item.expiry_flag}}</b-badge>
                      </h6>
                    </div>
                  </template>
                  <template slot="action" slot-scope="row6">
                    <b-button variant="outline-primary" @click="editDocumentValidatorMaster(row6.item)"
                      id="addButtonLoader" size="sm">Update
                  <CustomLoader v-if="isLoading" :width="70"></CustomLoader>  
                  </b-button>
                    <b-button v-if="
                    row6.item.documentFileName != '' &&
                    row6.item.documentFileName != null
                    " @click="openAllPridelDocumentListModal(row6.item)" style="margin-left: 2px;"
                      variant="outline-success" id="addButtonLoader" size="sm">History</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="5" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import MultiFileUploader from "../common/MultiFileUploader.vue";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    this.generateDocumentnumber();
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/DocumentValidatorMaster");
      if (globalPermissionStatus("Pridel Document")) {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Pridel Document")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.getAllDocumentValidatorMasterList();
      
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
    this.$store.dispatch(
      "common/setAllDocumentTypeList",
      JSON.stringify({
        itemCode: "DocumentTypeList",
      })
    );
  },
  data() {
    return {
      ExcelBtnName: "Export As Excel",
      // Added By Shreshth Gahlot Start
      DocumentTypeModal: {
        documentTypeId: "",
        documentName: "",
        description: "",
        TypeofAdd: "Document Type Master Add",
      },
      DocumentTypeError: ["Please Document Name"],
      DocumenterrorList: {
        documentName: "",
      },
      // Added By Shreshth Gahlot End
      addEditCard: false,
      isLoading: false,
      selectDateFormat,
      HistoryColumns: [
        {
          key: "pri_docId",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "priDocNumber",
          label: "Document Number",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "Username",
          label: "Username",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentName",
          label: "Document Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "pri_docName",
          label: "Document File Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "startDate",
          label: "Document Issue Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "EndDate",
          label: "Document Expiry Date",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      Columns: [
        {
          key: "documentvalidatorId",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentTypeName",
          label: "Document Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentName",
          label: "Document Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentIssueDate",
          label: "Document Dates",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentEndDate",
          label: "Document Expiry Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ToEmail",
          label: "Document Emails",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentFileName",
          label: "Document Files",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "isDocumentActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      docURL: URL_BASE_DOC,
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      sortBy: null,
      sortDesc: false,
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get(),
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      DocumentValidatorMaster: {
        documentvalidatorId: "",
        fk_doc_type_id: "",
        documentNumber: "",
        documentName: "",
        documentIssueDate: "",
        documentEndDate: "",
        documentRemainderDate: "",
        documentFileName: "",
        ToEmail: "",
        CCEmail: "",
        isDocumentActive: true,
        TypeofAdd: "Document Validator Master Add",
      },
      DocumentValidatorMasterError: [
        "Please Select Document Type",
        "Please Click on Genrate Button and Genrate Document Number",
        "Please Enter Document Name",
        "Please Choose Document Issue Date",
        "Please Choose Document End Date",
        "Please Choose Document Remainder Date",
        "Please Enter Email TO",
        "Please Enter Email CC",
        "Please Choose Document File",
      ],
      errorList: {
        fk_doc_type_id: "",
        documentNumber: "",
        documentName: "",
        documentIssueDate: "",
        documentEndDate: "",
        documentRemainderDate: "",
        ToEmail: "",
        CCEmail: "",
        documentFileName: "",
      },
      All_Document_Validator_List_data: [],
      All_Pridel_Document_data: [],
      All_Document_TypeList: [],
      validate: true,
      visible: false,
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    MultiFileUploader,
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.DocumentValidatorMaster.documentFileName = file;
      //AJAY
      if(this.DocumentValidatorMaster.EmailSentStatus == 1){
        this.EndDateSelect('',1);
      }
    });
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  methods: {
    generateDocumentnumber() {
      const length = 8;
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      this.DocumentValidatorMaster.documentNumber = result;
    },
    PrintValidity_Doc(pridel_doc) {
      this.openSignedDocument(`ASSIGNMENT_UPLOADS/${pridel_doc}`);
    },
    EndDateSelect(item, mailstatus) {
      var selectedDate = '';
      if(mailstatus == 1 && item == '') {
        selectedDate = new Date();
        let TodayDate = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate()
        ).toDateString();
        this.DocumentValidatorMaster.documentIssueDate = TodayDate;
      } else {
        selectedDate = new Date(item);
      }
      let oneYearAfter = new Date(
        selectedDate.getFullYear() + 1,
        selectedDate.getMonth(),
        selectedDate.getDate() - 1
      );
      let RemainderDate = new Date(
        selectedDate.getFullYear() + 1,
        selectedDate.getMonth(),
        selectedDate.getDate() - 30
      );

      // Extract the year, month, and day from the oneYearAfter date object
      let year = oneYearAfter.getFullYear();
      let month = oneYearAfter.getMonth() + 1; // Note: month is zero-indexed, so add 1
      let day = oneYearAfter.getDate();

      let Remainderyear = RemainderDate.getFullYear();
      let Remaindermonth = RemainderDate.getMonth() + 1; // Note: month is zero-indexed, so add 1
      let Remainderday = RemainderDate.getDate();

      let formattedDate = `${year}-${month
        .toString()
        .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
      let formattedRemainderDate = `${Remainderyear}-${Remaindermonth.toString().padStart(
        2,
        "0"
      )}-${Remainderday.toString().padStart(2, "0")}`;

      console.log('Shreshth Gahlot formattedDate => ', formattedDate);
      console.log('Shreshth Gahlot formattedRemainderDate => ', formattedRemainderDate);

      this.DocumentValidatorMaster.documentEndDate = formattedDate;
      this.DocumentValidatorMaster.documentRemainderDate = formattedRemainderDate;
    },
    activateDocumentValidatorMaster() {
      if (
        this.DocumentValidatorMaster.isDocumentActive == 1 ||
        this.DocumentValidatorMaster.isDocumentActive == true
      ) {
        this.DocumentValidatorMaster.isDocumentActive = false;
      } else if (
        this.DocumentValidatorMaster.isDocumentActive == 0 ||
        this.DocumentValidatorMaster.isDocumentActive == false
      ) {
        this.DocumentValidatorMaster.isDocumentActive = true;
      }
    },
    clearErrVal() {
      this.DocumentValidatorMaster = {
        documentvalidatorId: "",
        fk_doc_type_id: "",
        documentNumber: "",
        documentName: "",
        documentIssueDate: "",
        documentEndDate: "",
        documentRemainderDate: "",
        documentFileName: "",
        isDocumentActive: true,
        TypeofAdd: "Document Validator Master Add",
      };
      this.errorList = {
        fk_doc_type_id: "",
        documentNumber: "",
        documentName: "",
        documentIssueDate: "",
        documentEndDate: "",
        documentRemainderDate: "",
        ToEmail: "",
        CCEmail: "",
        documentFileName: "",
      };
    },
    activateDocumentValidator(item) {
      item.isDocumentActive = item.isDocumentActive == 1 ? 0 : 1;
      let payload = {
        itemCode: "Document_Validator_Status_Update",
        DocumentValidator: item,
      };
      // JSON.stringify();
      // await
      CommonService.getActivateStatus(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("All_Document_Validator_Status response=>", data);
          }
        })
        .catch((error) => {
          console.log("Catch on All_Document_Validator_Status Error: ", error);
        });
    },
    previousSalesView() {
      window.history.go(-1);
    },
    filterClear() {
      this.DocumentValidatorMaster = {
        documentvalidatorId: "",
        fk_doc_type_id: "",
        documentName: "",
        documentIssueDate: "",
        documentEndDate: "",
        documentRemainderDate: "",
        documentFileName: "",
        ToEmail: "",
        CCEmail: "",
        isDocumentActive: true,
        TypeofAdd: "Document Validator Master Add",
      };
    },
    editDocumentValidatorMaster(item) {
      console.log("Priyanshu SIngh=>",item)
      this.clearErrVal();
      this.isLoading = true;
     this.addEditCard = true;
      this.All_Document_TypeList = this.$store.getters["common/getAllDocumentTypeList"];
      item.TypeofAdd = "Document Validator Master Add";
      this.DocumentValidatorMaster = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
      this.All_Document_TypeList = this.$store.getters["common/getAllDocumentTypeList"];
    },
    validateDocumentValidatorMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.DocumentValidatorMaster[x] == "" ||
          this.DocumentValidatorMaster[x] == undefined ||
          this.DocumentValidatorMaster[x] == null
        ) {
          console.log(
            "this.DocumentValidatorMaster[x]=>",
            this.DocumentValidatorMaster[x],
            x
          );
          console.log("this.DocumentValidatorMaster[x]=>", this.DocumentValidatorMaster);
          this.errorList[x] = this.DocumentValidatorMasterError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    addDocumentValidatorMaster() {
      this.validateDocumentValidatorMaster();
      this.DocumentValidatorMaster.TypeofAdd = "Document Validator Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;

      let payload = {
        itemCode: "add_Document_Validator_Details",
        DocumentValidatorMaster: this.DocumentValidatorMaster,
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        CommonService.getAllCommonMaster(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.documentvalidatorId != "" && data.documentvalidatorId != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.addEditCardFunc();
              this.getAllDocumentValidatorMasterList();
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Document Validator Error: ", error);
          });
      }
    },
    getReportsReverse(id) {
      let excelIdGivin = "";
      if (id == "Document_Validator_LIST_EXCEL") {
        excelIdGivin = "Document_Validator_LIST_EXCEL";
      }
      let payload = {
        excelId: excelIdGivin,
        Filter: this.Filter,
      };
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      this.ExcelBtnName = btnName;
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    getAllDocumentValidatorMasterList() {
      this.isLoading = true;
      let payload = {
        itemCode: "All_Document_Validator_List",
        Filter: this.Filter,
      };
      CommonService.getAllCommonMaster(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.All_Document_Validator_List_data = data.All_Document_Validator_List_data;
            this.totalRows = data.All_Document_Validator_List_data.length;
            console.log(" All_Document_Validator_List response=>", data);
          } else {
            this.All_Document_Validator_List_data = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_Document_Validator_List Error: ", error);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function () {
        return $("#portLocationNew").DataTable();
      });
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllDocumentValidatorMasterList();
      }, 1000);
    },
    setFocus: function () {
      // Note, you need to add a ref="search" attribute to your input.
      this.isLoading = false;
      this.$refs.search.focus();
    },
    openAllPridelDocumentListModal(item) {
      this.fetchUserDocumentList(item);
    },
    fetchUserDocumentList(item){
      let payload = {
        itemCode: "All_Document_Validator_Log_List",
        documentvalidatorId: item.documentvalidatorId
      };
      // JSON.stringify();
      // await
      CommonService.getAllCommonMaster(payload)
      .then((response) => {
        const { data, status, statusText } = response;
        if (status == 200 && data) {
          this.All_Pridel_Document_data = data.All_Pridel_Document_data;
          console.log(" All_Pridel_Document_data response=>", data);
        } else {
          this.All_Pridel_Document_data = [];
        }
        this.$refs["DocumentList-modal"].show();
        this.isLoading = false;
      })
      .catch((error) => {
        console.log("Catch on All_Pridel_Document_data Error: ", error);
      });
    },
    hideAllPridelDocumentListType() {
      this.$refs["DocumentList-modal"].hide();
      this.isLoading = false;
    },
    // Added By Shreshth Gahlot Start
    openDocumentValidatorModal() {
      this.isLoading = false;
      this.$refs["DocumentType-modal"].show();
    },
    hideDocumentType() {
      this.$refs["DocumentType-modal"].hide();
      this.isLoading = false;

      //   this.All_Document_TypeList = this.$store.getters["common/getAllDocumentTypeList"];
      //   console.log("this.All_Document_TypeList=>", this.All_Document_TypeList);
    },
    validateDocumentType() {
      let validate_new = true;
      Object.keys(this.DocumenterrorList).map((x, index) => {
        if (this.DocumentTypeModal[x] == "") {
          this.DocumenterrorList[x] = this.DocumentTypeModal[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addDocumentType() {
      this.validateDocumentType();
      this.DocumentTypeModal.TypeofAdd = "Document Type Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;
      $("#addButtonLoader").css("display", "none");
      $("#loader").css("display", "block");

      let payload = {
        itemCode: "add_Document_Type",
        DocumentTypeModal: this.DocumentTypeModal,
      };
      if (payload.itemCode == "add_Document_Type") {
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          CommonService.getDocumentTypeMaster(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.documentTypeId) {
                this.getDocumentType();
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              if (data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.hideDocumentType();
            })
            .catch((error) => {
              console.log("Catch on Document Validator Error: ", error);
            });
        }
      }
    },
    getDocumentType() {
      let payload = {
        itemCode: "DocumentTypeList",
      };
      payload = JSON.stringify(payload);
      CommonService.getAllClientList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.All_Document_TypeList = data.DocumentTypeList;
          console.log("this.All_Document_TypeList=>", data);
        })
        .catch((error) => {
          console.log("Catch on Document Type Error: ", error);
        });
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// documentValidatorMaster.vue?1eff2123